/**
 * Performs device detection
 *
 * @module app/components/MobileDetect
 */

/**
 * Method to return mobile user agent
 *
 * @returns {Object}
 *
 * @public
 */
var isMobile = function () {

    return {

        /**
         * Checks if Android
         *
         * @returns {boolean}
         *
         * @private
         */
        Android: function () {

            return (/Android/i)
                .test(navigator.userAgent);
        },

        /**
         * Checks if BB
         *
         * @returns {boolean}
         *
         * @private
         */
        BlackBerry: function () {

            return (/BlackBerry/i)
                .test(navigator.userAgent);
        },

        /**
         * Checks if iOS
         *
         * @returns {boolean}
         *
         * @provate
         */
        iOS: function () {

            return (/iPhone|iPad|iPod/i)
                .test(navigator.userAgent);
        },

        /**
         * Check if windows
         *
         * @returns {boolean}
         *
         * @private
         */
        Windows: function () {

            return (/IEMobile/i)
                .test(navigator.userAgent);
        },

        /**
         * Checks if any of the above
         *
         * @returns {boolean}
         *
         * @private
         */
        any: function () {

            return (
                !(
                    !isMobile().Android() &&
                    !isMobile().BlackBerry() &&
                    !isMobile().iOS() &&
                    !isMobile().Windows()
                )
            );
        },
    };
};

/**
 * Methods to be public
 *
 * @type {Object}
 */
var api = {

    /**
     * Perform initialisation.
     *
     * @returns {object}
     *
     * @public
     */
    init: function () {

        return isMobile();
    },
};

export default api;
